import { render, staticRenderFns } from "./PropertiesList.vue?vue&type=template&id=4ba67986"
import script from "./PropertiesList.vue?vue&type=script&lang=js"
export * from "./PropertiesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports